import React from "react";
import CrudManager from "../components/CrudManager";
import { api, resolveMediaUrl } from "../../lib/api";

const fields = [
  { name: "title", label: "Title" },
  { name: "category", label: "Category", type: "select", options: ["Campus", "Academics", "Facilities", "Events"], defaultValue: "Campus", required: true },
  { name: "date", label: "Date", type: "date" },
  { name: "image.url", label: "Gallery Image", type: "image", required: true, fullWidth: true },
  { name: "image.alt", label: "Image Alt Text" },
  { name: "position", label: "Display Position", type: "number", defaultValue: 0, min: 0 },
  { name: "isActive", label: "Gallery Status", type: "checkbox", defaultValue: true, help: "Show on website" },
];

export default function Galleries() {
  return <CrudManager title="Gallery" singular="Gallery Image" fields={fields} apiResource={api.galleries} columns={[
    { label: "Image", render: (item) => item.image?.url ? <img className="admin-table-image" src={resolveMediaUrl(item.image.url)} alt={item.image.alt || item.title || "Gallery"} /> : "—" },
    { label: "Title", render: (item) => item.title || "Untitled" },
    { label: "Category", accessor: "category" },
    { label: "Status", render: (item) => <span className={`admin-badge ${item.isActive ? "success" : "muted"}`}>{item.isActive ? "Active" : "Hidden"}</span> },
  ]} />;
}
